<template>
  <v-container fluid class="revert-page">
    <!-- Revert Form Confirm Dialog -->
    <v-dialog v-model="revertFormDialog" max-width="460" content-class="revert-confirm-dialog">
      <div class="revert-confirm-card">
        <h3 class="revert-confirm-card__title">{{ submitProperties.text }}</h3>
        <p class="revert-confirm-card__message">{{ submitProperties.msg }}</p>
        <div class="revert-confirm-card__actions">
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--cancel"
            @click="revertFormDialog = false"
          >
            Cancel
          </button>
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--confirm"
            :disabled="apiSubmit.isLoading"
            @click="modalRevertForm()"
          >
            Submit
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Revert Case Confirm Dialog -->
    <v-dialog v-model="revertCaseDialog" max-width="460" content-class="revert-confirm-dialog">
      <div class="revert-confirm-card">
        <h3 class="revert-confirm-card__title">Revert Case Back To Tab 3.0</h3>
        <p class="revert-confirm-card__message">Are you sure to revert this case?</p>
        <div class="revert-confirm-card__actions">
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--cancel"
            @click="revertCaseDialog = false"
          >
            Cancel
          </button>
          <button
            class="revert-confirm-card__btn revert-confirm-card__btn--danger"
            @click="revertCase()"
          >
            Revert
          </button>
        </div>
      </div>
    </v-dialog>

    <div class="revert-page__inner">
    <!-- Alert -->
    <AAlertBanner :messages="alertError" hide-title />

    <!-- Hero. No surface of its own: the sheet under it is the panel. -->
    <div class="revert-hero">
      <button
        type="button"
        class="back-btn"
        aria-label="Back"
        @click="redirectBack()"
      >
        <v-icon size="20">mdi-arrow-left</v-icon>
      </button>
      <div class="revert-hero__info">
        <span class="revert-hero__eyebrow">Grant &amp; Form Revert</span>
        <h1 v-if="!loadingDialog" class="revert-hero__title">
          {{ model.add.name }}
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="revert-hero__info-icon">
                mdi-information-slab-circle
              </v-icon>
            </template>
            2 Complete Form + Grant Approval No. consider as complete form
          </v-tooltip>
        </h1>
      </div>
    </div>

    <TrainingDaysListingComponent
      v-if="isHrdcAdminRoles"
      :datas="staticTaxpodData"
    ></TrainingDaysListingComponent>

    <!-- Application Details Section -->
    <div class="section-card">
      <div class="section-header">
        <v-icon color="white" small>mdi-file-document-outline</v-icon>
        <span class="section-header__title">Application Details</span>
      </div>
      <div class="section-body">
        <v-row>
          <v-col cols="12" md="6">
            <!-- Programme Name -->
            <div class="form-group">
              <label class="form-group__label">Programme Name</label>
              <v-text-field
                dense
                outlined
                hide-details="auto"
                class="app-input"
                v-model="formData.programmeName"
                :error-messages="errorField.programmeName"
              ></v-text-field>
            </div>

            <!-- Company Name -->
            <div class="form-group">
              <label class="form-group__label">Company Name</label>
              <v-text-field
                dense
                outlined
                hide-details="auto"
                class="app-input"
                disabled
                v-model="formData.companyName"
              ></v-text-field>
            </div>

            <!-- Subscription Date -->
            <div class="form-group">
              <label class="form-group__label">Subscription Date</label>
              <v-text-field
                :value="subscriptionDate"
                outlined
                dense
                readonly
                disabled
                prepend-inner-icon="mdi-calendar"
                placeholder="No date selected"
                hide-details="auto"
                class="app-input"
              ></v-text-field>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <!-- Refund Type -->
            <div class="form-group">
              <label class="form-group__label">
                Refund Type
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      size="16"
                      class="form-group__info"
                      v-on="on"
                    >mdi-information-outline</v-icon>
                  </template>
                  <span>Manual Invoice will require 2 if refund type is 70/30</span>
                </v-tooltip>
              </label>
              <v-select
                v-model="formData.refundType"
                :items="refundTypeItems"
                outlined
                dense
                placeholder="Select refund type"
                hide-details="auto"
                :error-messages="errorField.refundType"
                class="app-input"
                @change="changeRefundType()"
              ></v-select>
            </div>

            <!-- Request Invoice Amount -->
            <div v-show="requestManualInvoiceDisplay">
              <div class="form-group">
                <label class="form-group__label">Invoice Amount</label>
                <v-text-field
                  dense
                  outlined
                  hide-details="auto"
                  class="app-input"
                  type="number"
                  hide-spin-buttons
                  v-model="formData.requestManualInvoiceAmount"
                  :error-messages="errorField.requestManualInvoiceAmount"
                ></v-text-field>
              </div>
            </div>

            <!-- 70/30 -->
            <div v-show="seventyThirtyCase">
              <div class="form-group">
                <label class="form-group__label">70/30 Split</label>
                <div class="form-row--inline">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    class="app-input"
                    type="number"
                    hide-spin-buttons
                    placeholder="70% claim amount"
                    v-model="formData.seventyPercent"
                    :error-messages="errorField.seventyPercent"
                  ></v-text-field>
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    class="app-input"
                    type="number"
                    hide-spin-buttons
                    placeholder="30% claim amount"
                    v-model="formData.thirtyPercent"
                    :error-messages="errorField.thirtyPercent"
                  ></v-text-field>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- Grant Details & Form Details -->
    <div class="cards-grid">
      <!-- GRANT DETAILS -->
      <div class="cards-column">
        <div class="section-card">
          <div class="section-header">
            <v-icon color="white" small>mdi-certificate-outline</v-icon>
            <span class="section-header__title">Grant Details</span>
            <span
              class="status-pill"
              :class="caseIcon.grantIcon.color === 'green' ? 'status-pill--complete' : 'status-pill--incomplete'"
            >
              <svg v-if="caseIcon.grantIcon.color === 'green'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
              {{ caseIcon.grantIcon.color === 'green' ? 'Complete' : 'Incomplete' }}
            </span>
          </div>
          <div class="section-body">
            <!-- Auto-captured grant email data -->
            <div v-if="displayAutoCapturedData" class="grant-email-card">
              <div class="grant-email-card__header">
                <div class="grant-email-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                  </svg>
                </div>
                <span class="grant-email-card__title">Grant Email Details</span>
                <div class="grant-email-card__actions">
                  <button
                    class="ge-btn ge-btn--approve"
                    @click="embedGrantData(true)"
                    :disabled="!disabledApprovalGrantEmailBtn"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                    Approve
                  </button>
                  <button
                    class="ge-btn ge-btn--revert"
                    @click="embedGrantData(false)"
                    :disabled="disabledApprovalGrantEmailBtn"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                    </svg>
                    Revert
                  </button>
                </div>
              </div>
              <div class="grant-email-card__body">
                <div class="ge-rows">
                  <div class="ge-row">
                    <span class="ge-row__label">Company Name</span>
                    <span class="ge-row__value">{{ grantEmailData.hrdcCompanyName }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Programme Name</span>
                    <span class="ge-row__value">{{ grantEmailData.programmeName }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Price</span>
                    <span class="ge-row__value ge-row__value--highlight">{{ grantEmailData.price }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Grant Approval No.</span>
                    <span class="ge-row__value">{{ grantEmailData.grantApprovalNo }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Grant Approval Date</span>
                    <span class="ge-row__value">{{ grantEmailData.grantApprovalDate }}</span>
                  </div>
                  <div class="ge-row">
                    <span class="ge-row__label">Subscription Date</span>
                    <span class="ge-row__value">{{ grantEmailData.trainingDate }}</span>
                  </div>
                </div>
                <div class="ge-attachment">
                  <div class="ge-attachment__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                    </svg>
                  </div>
                  <span class="ge-attachment__text">Grant Email Attachment</span>
                  <button class="ge-attachment__btn" @click="previewBlobAttachment()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                    Preview
                  </button>
                </div>
              </div>
            </div>

            <hr v-if="displayAutoCapturedData" class="section-divider" />

            <!-- Grant Approval No. -->
            <div class="form-group">
              <label class="form-group__label">Grant Approval No.</label>
              <div class="grant-input-wrap">
                <v-text-field
                  dense
                  outlined
                  hide-details="auto"
                  class="app-input"
                  v-model="formData.grantApprovalNo"
                  :error-messages="errorField.grantApprovalNo"
                ></v-text-field>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <button
                      class="grant-format-toggle"
                      :class="rareCaseGrantFlag ? 'grant-format-toggle--on' : 'grant-format-toggle--off'"
                      @click="toggleMarker"
                      v-on="on"
                    >
                      <span class="grant-format-toggle__track">
                        <span class="grant-format-toggle__thumb"></span>
                      </span>
                      <span class="grant-format-toggle__label">{{ rareCaseGrantFlag ? 'Validate' : 'Skip' }}</span>
                    </button>
                  </template>
                  <span>{{ rareCaseGrantFlag ? 'Will Check Grant Format' : 'No Check Grant Format' }}</span>
                </v-tooltip>
              </div>
            </div>

            <!-- Grant email attachment -->
            <div class="form-group">
              <label class="form-group__label">Grant Attachment</label>
              <div
                class="file-card"
                :class="formData.grantEmailAttachment ? 'file-card--has-file' : 'file-card--empty'"
                @drop.prevent="addDropFile($event, 'grantEmailAttachment', false)"
                @dragover.prevent
              >
                <div class="file-card__icon-wrap">
                  <div class="file-card__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
                <div class="file-card__info">
                  <span class="file-card__name">{{ formData.grantEmailAttachment ? formData.grantEmailAttachment.name : 'No file selected' }}</span>
                  <span class="file-card__hint">PDF or image</span>
                </div>
                <div class="file-card__actions">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <label class="file-card__btn" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                        <input type="file" class="file-card__hidden" accept=".pdf, image/*" @change="handleFileChange($event, 'grantEmailAttachment')" />
                      </label>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <button class="file-card__btn" @click="previewAttachment('grantEmailAttachment')" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                      </button>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                </div>
              </div>
              <div v-if="errorField.grantEmailAttachment" class="field-error">
                <ul v-if="Array.isArray(errorField.grantEmailAttachment)" class="field-error__list"><li v-for="(msg, idx) in errorField.grantEmailAttachment" :key="'grantAtchErr-' + idx">{{ msg }}</li></ul>
                <span v-else>{{ errorField.grantEmailAttachment }}</span>
              </div>
            </div>

            <!-- Grant Approved Date -->
            <div class="form-group">
              <label class="form-group__label">Grant Approved Date</label>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.grantApprovalNoSubmitDate"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    placeholder="Select date"
                    hide-details="auto"
                    :error-messages="errorField.grantApprovalNoSubmitDate"
                    class="app-input"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.grantApprovalNoSubmitDate"
                  no-title
                  scrollable
                  color="var(--app-accent)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </div>

            <!-- Grant Status -->
            <div class="form-group">
              <label class="form-group__label">Grant Status</label>
              <v-select
                v-model="formData.revertStatus"
                :items="grantRevertOpts"
                outlined
                dense
                placeholder="Select grant status"
                hide-details="auto"
                :error-messages="errorField.revertStatus"
                class="app-input"
              ></v-select>
            </div>

            <!-- Grant Remarks -->
            <div class="form-group">
              <label class="form-group__label">Grant Remarks</label>
              <v-textarea
                dense
                outlined
                hide-details="auto"
                class="app-input"
                auto-grow
                v-model="formData.remarks"
                :error-messages="errorField.remarks"
              ></v-textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- FORM DETAILS -->
      <div class="cards-column">
        <div class="section-card">
          <div class="section-header">
            <v-icon color="white" small>mdi-file-document-edit-outline</v-icon>
            <span class="section-header__title">Form Details</span>
            <span
              class="status-pill"
              :class="caseIcon.formIcon.color === 'green' ? 'status-pill--complete' : 'status-pill--incomplete'"
            >
              <svg v-if="caseIcon.formIcon.color === 'green'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="status-pill__icon"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
              {{ caseIcon.formIcon.color === 'green' ? 'Complete' : 'Incomplete' }}
            </span>
          </div>
          <div class="section-body">
            <!-- JD14 -->
            <div class="form-group">
              <label class="form-group__label">JD14</label>
              <div
                class="file-card"
                :class="formData.jd14FileUrl ? 'file-card--has-file' : 'file-card--empty'"
                @drop.prevent="addDropFile($event, 'jd14FileUrl')"
                @dragover.prevent
              >
                <div class="file-card__icon-wrap">
                  <div class="file-card__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
                <div class="file-card__info">
                  <span class="file-card__name">{{ formData.jd14FileUrl ? formData.jd14FileUrl.name : 'No file selected' }}</span>
                  <span class="file-card__hint">PDF only</span>
                </div>
                <div class="file-card__actions">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <label class="file-card__btn" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                        <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 'jd14FileUrl')" />
                      </label>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <button class="file-card__btn" @click="previewAttachment('jd14FileUrl')" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                      </button>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                </div>
              </div>
              <div v-if="errorField.jd14FileUrl" class="field-error">
                <ul v-if="Array.isArray(errorField.jd14FileUrl)" class="field-error__list"><li v-for="(msg, idx) in errorField.jd14FileUrl" :key="'jd14Err-' + idx">{{ msg }}</li></ul>
                <span v-else>{{ errorField.jd14FileUrl }}</span>
              </div>
            </div>

            <!-- T3 -->
            <div class="form-group">
              <label class="form-group__label">T3</label>
              <div
                class="file-card"
                :class="formData.t3FileUrl ? 'file-card--has-file' : 'file-card--empty'"
                @drop.prevent="addDropFile($event, 't3FileUrl')"
                @dragover.prevent
              >
                <div class="file-card__icon-wrap">
                  <div class="file-card__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
                <div class="file-card__info">
                  <span class="file-card__name">{{ formData.t3FileUrl ? formData.t3FileUrl.name : 'No file selected' }}</span>
                  <span class="file-card__hint">PDF only</span>
                </div>
                <div class="file-card__actions">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <label class="file-card__btn" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                        <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 't3FileUrl')" />
                      </label>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <button class="file-card__btn" @click="previewAttachment('t3FileUrl')" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                      </button>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                </div>
              </div>
              <div v-if="errorField.t3FileUrl" class="field-error">
                <ul v-if="Array.isArray(errorField.t3FileUrl)" class="field-error__list"><li v-for="(msg, idx) in errorField.t3FileUrl" :key="'t3Err-' + idx">{{ msg }}</li></ul>
                <span v-else>{{ errorField.t3FileUrl }}</span>
              </div>
            </div>

            <!-- Attendance Form -->
            <div v-if="showAttendanceForm" class="form-group">
              <label class="form-group__label">Attendance Form</label>
              <div
                class="file-card"
                :class="formData.attendanceForm ? 'file-card--has-file' : 'file-card--empty'"
                @drop.prevent="addDropFile($event, 'attendanceForm')"
                @dragover.prevent
              >
                <div class="file-card__icon-wrap">
                  <div class="file-card__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
                <div class="file-card__info">
                  <span class="file-card__name">{{ formData.attendanceForm ? formData.attendanceForm.name : 'No file selected' }}</span>
                  <span class="file-card__hint">PDF only</span>
                </div>
                <div class="file-card__actions">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <label class="file-card__btn" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                        <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 'attendanceForm')" />
                      </label>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <button class="file-card__btn" @click="previewAttachment('attendanceForm')" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                      </button>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                </div>
              </div>
              <div v-if="errorField.attendanceForm" class="field-error">
                <ul v-if="Array.isArray(errorField.attendanceForm)" class="field-error__list"><li v-for="(msg, idx) in errorField.attendanceForm" :key="'attFormErr-' + idx">{{ msg }}</li></ul>
                <span v-else>{{ errorField.attendanceForm }}</span>
              </div>
            </div>

            <!-- Attendance List -->
            <div v-if="showAttendanceList" class="form-group">
              <label class="form-group__label">Attendance List</label>
              <div
                class="file-card"
                :class="formData.attendanceList ? 'file-card--has-file' : 'file-card--empty'"
                @drop.prevent="addDropFile($event, 'attendanceList')"
                @dragover.prevent
              >
                <div class="file-card__icon-wrap">
                  <div class="file-card__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
                <div class="file-card__info">
                  <span class="file-card__name">{{ formData.attendanceList ? formData.attendanceList.name : 'No file selected' }}</span>
                  <span class="file-card__hint">PDF only</span>
                </div>
                <div class="file-card__actions">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <label class="file-card__btn" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                        <input type="file" class="file-card__hidden" accept=".pdf" @change="handleFileChange($event, 'attendanceList')" />
                      </label>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <button class="file-card__btn" @click="previewAttachment('attendanceList')" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                      </button>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                </div>
              </div>
              <div v-if="errorField.attendanceList" class="field-error">
                <ul v-if="Array.isArray(errorField.attendanceList)" class="field-error__list"><li v-for="(msg, idx) in errorField.attendanceList" :key="'attListErr-' + idx">{{ msg }}</li></ul>
                <span v-else>{{ errorField.attendanceList }}</span>
              </div>
            </div>

            <!-- Form Revert Date -->
            <div class="form-group">
              <label class="form-group__label">Form Revert Date</label>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.formSubmitDate"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    placeholder="Select date"
                    hide-details="auto"
                    :error-messages="errorField.formSubmitDate"
                    class="app-input"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.formSubmitDate"
                  no-title
                  scrollable
                  color="var(--app-accent)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu2.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </div>

            <!-- Form Status -->
            <div class="form-group">
              <label class="form-group__label">Form Status</label>
              <v-select
                v-model="formData.formRevertStatus"
                :items="formRevertOpts"
                outlined
                dense
                placeholder="Select form status"
                hide-details="auto"
                :error-messages="errorField.formRevertStatus"
                class="app-input"
              ></v-select>
            </div>

            <!-- Form Remarks -->
            <div class="form-group">
              <label class="form-group__label">Form Remarks</label>
              <v-textarea
                dense
                outlined
                hide-details="auto"
                class="app-input"
                auto-grow
                v-model="formData.formRemarks"
                :error-messages="errorField.formRemarks"
              ></v-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action bar -->
    <div
      v-if="isHrdcAdminRoles && (displayRevertBtn || !btnDisabled)"
      class="form-actions"
    >
      <button
        v-if="displayRevertBtn"
        class="action-btn action-btn--revert"
        :disabled="apiRevertCase.isLoading"
        @click="revertCaseDialog = true"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
        </svg>
        Revert Case
      </button>
      <div v-else></div>

      <button
        v-if="!btnDisabled"
        class="action-btn action-btn--submit"
        :disabled="apiSubmit.isLoading"
        @click="revertFormDialog = true"
      >
        <v-icon size="18">mdi-check-circle-outline</v-icon>
        Submit
      </button>
      <div v-else></div>
    </div>
    </div>

    <HrdcLoader
      :loadingDialog="loadingDialog"
      :loadingText="loadingText"
    ></HrdcLoader>
  </v-container>
</template>

<script>
import moment from "moment";
import Api from "@/objects/api";
import { mapState } from "vuex";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc_event/objects/globalData";
import TrainingDaysListingComponent from "@/components/views/TrainingDaysListingComponent";

export default {
  mixins: [hrdcFunction],
  components: {
    TrainingDaysListingComponent,
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
    submitProperties() {
      let status = null;
      if (
        this.formData.revertStatus == 0 ||
        this.formData.formRevertStatus == 0
      ) {
        status = {
          text: "Submit Incomplete Form",
          color: "error",
          msg: "Please be informed that this form is incomplete, do you wish to proceed ?",
        };
      } else {
        if (
          this.formData.jd14FileUrl &&
          this.formData.t3FileUrl &&
          this.formData.grantApprovalNo
        ) {
          status = {
            text: "Submit Complete Form",
            color: "success",
            msg: "Please confirm that you wish to submit this form & HRDC Invoice will be generate automatically",
          };
        } else {
          status = {
            text: "Submit Incomplete Form",
            color: "error",
            msg: "Please be informed that this form is incomplete, do you wish to proceed ?",
          };
        }
      }

      return status;
    },
    subscriptionDate() {
      return this.formData.subscriptionDateRange.join(" - ");
    },
    seventyThirtyCase() {
      if (this.formData.refundType == 2) {
        return true;
      }
      return false;
    },
    showAttendanceForm() {
      // taxPOD (hrdc) = no attendance form; all others = yes
      return this.model.serviceKey !== "hrdc";
    },
    showAttendanceList() {
      const config = require("@/services/hrdc_event/eventRegistry").getEventConfig(this.service.key);
      return config ? config.hasAttendanceList : false;
    },
    caseIcon() {
      let grantIcon = {},
        formIcon = {};
      if (
        this.formData.jd14FileUrl &&
        this.formData.t3FileUrl &&
        this.formData.formRevertStatus &&
        this.formData.formSubmitDate
      ) {
        formIcon.icon = "mdi-check-circle";
        formIcon.color = "green";
      } else {
        formIcon.icon = "mdi-close-circle";
        formIcon.color = "red";
      }

      if (
        this.formData.grantApprovalNo &&
        this.formData.revertStatus &&
        this.formData.grantApprovalNoSubmitDate
      ) {
        grantIcon.icon = "mdi-check-circle";
        grantIcon.color = "green";
      } else {
        grantIcon.icon = "mdi-close-circle";
        grantIcon.color = "red";
      }

      return {
        formIcon,
        grantIcon,
      };
    },
    displayAutoCapturedData() {
      if (this.grantEmailData.hrdcCompanyName) {
        return true;
      }

      return false;
    },
  },
  props: ["params"],
  data: () => ({
    apiSubmit: new Api(),
    apiGetApplicationAttachment: new Api(),
    apiRevertCase: new Api(),
    apiDownloadOrPreviewAttachment: new Api(),
    apiGetXeroRefreshToken: new Api(),
    apiRefreshXeroToken: new Api(),
    apiGetXeroTenantId: new Api(),
    apiRequestXeroAccessToken: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    loadingDialog: false,
    loadingText: null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu2: false,
    currentStagePriority: 0,
    formData: {
      applicationNo: null,
      programmeName: null,
      grantApprovalNo: null,
      grantApprovalNoSubmitDate: null,
      formSubmitDate: null,
      jd14FileUrl: null,
      t3FileUrl: null,
      remarks: null,
      formRemarks: null,
      revertStatus: null, // Page revertGrantStatus
      formRevertStatus: null,
      dbRevertGrantStatus: null, // Database revertGrantStatus
      subscriptionMenu: false,
      subscriptionDateRange: [],
      refundType: null,
      seventyPercent: null,
      thirtyPercent: null,
      totalPrice: null,
      companyName: null,
      requestManualInvoiceAmount: null,
      grantEmailAttachment: null,
      oriCompanyName: null,
      oriPrice: null,
      oriGrantApprovalNo: null,
      oriProgrammeName: null,
      oriGrantApprovalDate: null,
      oriEmailAttachment: null,
      oriGrantStatus: null,
      attendanceForm: null,
      attendanceList: null,
    },
    errorField: {
      applicationNo: null,
      programmeName: null,
      grantApprovalNo: null,
      grantApprovalNoSubmitDate: null,
      formSubmitDate: null,
      jd14FileUrl: null,
      t3FileUrl: null,
      remarks: null,
      formRemarks: null,
      revertStatus: null,
      formRevertStatus: null,
      subscriptionMenu: null,
      subscriptionDateRange: null,
      refundType: null,
      seventyPercent: null,
      thirtyPercent: null,
      totalPrice: null,
      requestManualInvoiceAmount: null,
      grantEmailAttachment: null,
      attendanceForm: null,
      attendanceList: null,
    },
    revertFormDialog: false,
    revertCaseDialog: false,
    // grantRevertOpts / formRevertOpts come from the hrdcFunction mixin; this
    // pair is local because only this page offers it.
    refundTypeItems: [
      { text: "Normal", value: 1 },
      { text: "70% / 30%", value: 2 },
    ],
    editMode: false,
    btnDisabled: false,
    requestManualInvoiceDisplay: false,
    rareCaseGrantFlag: true,
    displayRevertBtn: false,
    originalGrantData: {
      emailAttachment: null,
    },
    grantEmailData: {
      emailAttachment: null,
      hrdcCompanyName: null,
      price: null,
      grantApprovalNo: null,
      programmeName: null,
      grantApprovalDate: null,
      trainingDate: null,
    },
    disabledApprovalGrantEmailBtn: true,
  }),
  async created() {
    this.showLoadingDialog();
    this.formData.applicationNo = this.$route.query._ausk;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Events Assignation.
    this.serviceDataAssignation(this.model.serviceKey);

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/revert_form/create-revert-form`,
        method: "post",
      },
      apiGetApplicationAttachment: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-application-attachment`,
        method: "post",
      },
      apiRevertCase: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/revert_form/revert-case`,
        method: "post",
      },
      apiDownloadOrPreviewAttachment: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/azure-download-or-preview-application-attachment`,
      },
      apiGetXeroRefreshToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/get-xero-token?date=${moment().format(
          "YYYY-MM-DD"
        )}`,
      },
      apiRefreshXeroToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/update-xero-token`,
        method: "put",
      },
      apiRequestXeroAccessToken: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/xero/request-xero-access-token`,
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.stages = await this.hrdcData.allStages;
    this.currentStagePriority =
      this.hrdcData.stageIndex[this.$store.state[this.service.key].data.stageId];

    this.rolesAssignation(this.auth.roles);
    if (!this.isHrdcAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    const grantApprovalStage =
      this.hrdcData.stageIndex[
        this.hrdcData.stagePriority.grantApprovalNoSubmitted
      ];

    const totallyIncompleteStage =
      this.hrdcData.stageIndex[
        this.hrdcData.stagePriority.clientRevertFormIncomplete
      ];

    let stageErrorMsg = null;
    let checkGreaterStage = this.hrdcData.stageSlug.clientRevertT3Form;
    if (
      this.currentStagePriority > grantApprovalStage &&
      this.currentStagePriority <= totallyIncompleteStage
    ) {
      stageErrorMsg = "This form is partially filled in";
      checkGreaterStage = grantApprovalStage;
    }

    this.checkFormAlreadyFilledGte(
      this.currentStagePriority,
      checkGreaterStage,
      stageErrorMsg
    );

    this.checkFormNotYetFilledLesser(
      this.currentStagePriority,
      this.hrdcData.stageSlug.sentConfirmationEmailToClient
    );

    // Get is there any uploaded attachment for jd14/t3.
    this.apiGetApplicationAttachment.setParams({
      applicationNo: this.$route.query._ausk,
    });
    this.apiGetApplicationAttachment.fetch();
    this.apiGetApplicationAttachment.setCallbackCompleted((response) => {
      try {
        const { data } = response;

        // General details.
        let grantApprovalNo = null;
        let grantApprovalNoSubmitDate = null;

        // Assign latest subscription date range.
        const subscriptionDate = data.ApplicationLog.find(
          (item) =>
            item.stageId ==
            this.hrdcData.stagePriority.subscriptionDateScheduled
        );

        if (subscriptionDate !== undefined) {
          this.formData.subscriptionDateRange = [
            moment(subscriptionDate.startDate, "YYYY-MM-DD HH:mm:ssZ").format(
              "DD/MM/YYYY"
            ),
            moment(subscriptionDate.endDate, "YYYY-MM-DD HH:mm:ssZ").format(
              "DD/MM/YYYY"
            ),
          ];
        }
        this.formData.companyName = data.oriCompanyName.toUpperCase();
        this.formData.programmeName = data.programmeName;
        this.formData.totalPrice = data.totalPrice;
        this.formData.refundType = data.refundType;
        this.formData.seventyPercent = Number(data.seventyPercentPrice).toFixed(
          2
        );
        this.formData.thirtyPercent = Number(data.thirtyPercentPrice).toFixed(
          2
        );
        this.formData.requestManualInvoiceAmount = data.totalPrice; // Default price.

        // Assign original data to re-append if user click 'Revert'.
        this.formData.oriCompanyName = data.oriCompanyName.toUpperCase();
        this.formData.oriPrice = data.totalPrice;
        this.formData.oriGrantApprovalNo = null;
        this.formData.oriProgrammeName = data.programmeName;
        this.formData.oriGrantApprovalDate = null;
        this.formData.oriEmailAttachment = null;
        this.formData.dbRevertGrantStatus = data.revertGrantStatus;

        // Append auto captured grant email data & display.
        const grantEmailHookData = JSON.parse(data.grantEmailHookData);

        if (grantEmailHookData) {
          this.grantEmailData.hrdcCompanyName =
            grantEmailHookData.hrdcCompanyName;
          this.grantEmailData.price = grantEmailHookData.price;
          this.grantEmailData.grantApprovalNo =
            grantEmailHookData.grantApprovalNo;
          this.grantEmailData.programmeName = grantEmailHookData.programmeName;
          this.grantEmailData.grantApprovalDate = moment(
            grantEmailHookData.grantApprovalDate
          ).format("YYYY-MM-DD");
          this.grantEmailData.emailAttachment =
            grantEmailHookData.emailAttachment;
          this.grantEmailData.trainingDate =
            grantEmailHookData.trainingDate ?? "-";
        }

        if (this.editMode) {
          // Grant Details.
          const grantRemarkArr = [
            this.hrdcData.stagePriority.grantApprovalNoSubmitted,
          ];
          grantApprovalNo = data.grantApprovalNo;

          // Check whether grant approval no. has been submitted or not.
          const checkGrant = data.ApplicationLog.find((obj) =>
            grantRemarkArr.includes(obj.stageId)
          );

          if (checkGrant !== undefined) {
            if (checkGrant.startDate) {
              grantApprovalNoSubmitDate = moment(checkGrant.startDate).format(
                "YYYY-MM-DD"
              );
            }
          }

          this.formData.grantApprovalNo = grantApprovalNo;

          // Check rare case flag.
          if (grantApprovalNo) {
            this.rareCaseGrantFlag =
              !this.hasMoreThanTwoUnderscores(grantApprovalNo);
          }

          this.formData.grantApprovalNoSubmitDate = grantApprovalNoSubmitDate;
          this.formData.revertStatus = data.revertGrantStatus;
          if (data.ApplicationLog.length > 0) {
            const grantRemarks = data.ApplicationLog.find((item) =>
              grantRemarkArr.includes(item.stageId)
            );
            if (grantRemarks) {
              this.formData.remarks = grantRemarks.remarks;
            }
          }

          // Form details.
          const jd14T3FormSubmittedStageId =
            this.hrdcData.stagePriority.jd14T3FormSubmitted;

          for (const item of data.ApplicationAttachment) {
            // Create a Blob object from the data
            const blob = new Blob([new Uint8Array(item.dataArray)]);

            // Create the File object
            const file = new File([blob], item.fileName, {
              type: "application/pdf",
            });

            switch (item.type) {
              case "JD14":
                this.formData.jd14FileUrl = file;
                break;

              case "T3":
                this.formData.t3FileUrl = file;
                break;

              case "HRDC_GRANT_EMAIL":
                this.formData.grantEmailAttachment = file;
                break;

              case "ATTENDANCE_FORM":
                this.formData.attendanceForm = file;
                break;

              case "ATTENDANCE_LIST":
                this.formData.attendanceList = file;
                break;
            }
          }

          let jd14T3FormSubmittedDate = null;

          const checkFormSubmitted = data.ApplicationLog.find(
            (obj) => obj.stageId == jd14T3FormSubmittedStageId
          );

          if (checkFormSubmitted !== undefined) {
            jd14T3FormSubmittedDate = moment(
              checkFormSubmitted.startDate
            ).format("YYYY-MM-DD");
          }

          this.formData.formSubmitDate = jd14T3FormSubmittedDate;
          this.formData.formRevertStatus = data.revertFormStatus;
          if (data.ApplicationLog.length > 0) {
            const formRemarks = data.ApplicationLog.find(
              (item) => item.stageId == jd14T3FormSubmittedStageId
            );
            if (formRemarks) {
              this.formData.formRemarks = formRemarks.remarks;
            }
          }

          if (data.refundType == 1) {
            this.requestManualInvoiceDisplay = true;
          }

          // If got assign request manual invoice amount, then assign request manual invoice amount, else use application pricing.
          if (data.requestManualInvoiceAmount) {
            this.formData.requestManualInvoiceAmount =
              data.requestManualInvoiceAmount;
          }

          // If passed stage of pending grant/form, then cannot be revert anymore.
          if (
            this.currentStagePriority <
            this.hrdcData.stageSlug.clientRevertT3Form
          ) {
            this.displayRevertBtn = true;
          }

          // Assign original data to re-append if user click 'Revert'.
          this.formData.oriGrantApprovalNo = grantApprovalNo;
          this.formData.oriGrantApprovalDate = grantApprovalNoSubmitDate;
          this.formData.oriGrantStatus = data.revertGrantStatus;
        } else {
          this.requestManualInvoiceDisplay = true;
        }

        this.hideLoadingDialog();
      } catch (err) {
        console.log(err);
      }
    });
  },
  methods: {
    handleFileChange(event, key) {
      const file = event.target.files[0];
      if (file) {
        this.formData[key] = file;
      }
    },
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      const fieldLabels = {
        requestManualInvoiceAmount: "Request Invoice Amount",
        grantApprovalNo: "Grant Approval No",
        grantApprovalNoSubmitDate: "Grant Approved Date",
        formSubmitDate: "Form Revert Date",
        revertStatus: "Grant Status",
        formRevertStatus: "Form Status",
        jd14FileUrl: "JD14",
        t3FileUrl: "T3",
        grantEmailAttachment: "Grant Attachment",
      };
      for (const key in response.data) {
        this.errorField[key] = null;
        let errors = response.data[key];
        // Fix "undefined is required" messages
        if (Array.isArray(errors)) {
          errors = errors.map(function(msg) {
            return msg.replace(/^undefined\b/, fieldLabels[key] || key);
          });
        } else if (typeof errors === 'string') {
          errors = errors.replace(/^undefined\b/, fieldLabels[key] || key);
        }
        this.errorField[key] = errors;
      }
    },
    addDropFile(e, key, strictPdf = true) {
      let file = e.dataTransfer.files[0];

      if (strictPdf) {
        if (!file.type.match("pdf.*")) {
          this.errorField[key] = "Please select pdf file format";
          return;
        }
      }

      this.formData[key] = file;
    },
    modalRevertForm() {
      this.revertFormDialog = !this.revertFormDialog;
      this.submit();
    },
    changeRefundType() {
      if (this.formData.refundType == 1) {
        this.formData.seventyPercent = null;
        this.formData.thirtyPercent = null;

        // Enable request manual invoice amount.
        this.requestManualInvoiceDisplay = true;
      } else {
        // Assign split amount.
        const totalPrice = this.formData.totalPrice;
        this.formData.seventyPercent = (totalPrice * 0.7).toFixed(2);
        this.formData.thirtyPercent = (totalPrice * 0.3).toFixed(2);

        // Disable request manual invoice amount.
        this.requestManualInvoiceDisplay = false;
      }
    },
    revertCase() {
      this.apiRevertCase.setParams({
        applicationUuid: this.formData.applicationNo,
      });
      this.apiRevertCase.setCallbackCompleted((response) => {
        try {
          this.showLoadingDialog();
          this.revertCaseDialog = false;
          const { status, data } = response;

          if (!status) {
            this.$store.dispatch("showMessage", {
              message: data,
              messageType: "error",
              timeout: 2000,
            });
            return;
          }

          this.$store.dispatch("showMessage", {
            message: data,
            messageType: "success",
            timeout: 2000,
          });

          this.$router.push({
            name: this.eventRoute("Application"),
            query: {
              viewId: this.$store.state[this.service.key].data.viewId,
            },
          });
        } catch (err) {
          console.log(err);
        } finally {
          this.hideLoadingDialog();
        }
      });
      this.apiRevertCase.fetch();
    },
    redirectBack() {
      let route = this.eventRoute("Application");
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state[this.service.key].data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
    },
    toggleMarker() {
      this.rareCaseGrantFlag = !this.rareCaseGrantFlag;
    },
    hasMoreThanTwoUnderscores(word) {
      return word.split("_").length > 3;
    },
    async previewBlobAttachment() {
      this.showLoadingDialog();

      let fileUrl = this.grantEmailData.emailAttachment;
      fileUrl = fileUrl.replace(/\.[^.]+$/, (match) => match.toLowerCase());

      await this.$axios
        .get(this.apiDownloadOrPreviewAttachment.url, {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            filePath: fileUrl,
          },
        })
        .then((response) => {
          const blobUrl = URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );

          window.open(blobUrl, "_blank");

          this.hideLoadingDialog();
        })
        .catch((error) => {
          if ((error.response.status == 404) | true) {
            this.$store.dispatch("showMessage", {
              message:
                "Failed to Preview/Download attachment, kindly contact administrator",
              messageType: "error",
              timeout: 2000,
            });
          }
          this.hideLoadingDialog();
        });
    },
    previewAttachment(fileType) {
      try {
        if (!this.formData[fileType]) {
          this.$store.dispatch("showMessage", {
            message: "No Preview Available",
            messageType: "info",
          });
          return;
        }

        let url = null;
        let newWindow = null;
        switch (fileType) {
          default:
            url = URL.createObjectURL(this.formData[fileType]);
            newWindow = window.open(url, "_blank");
            break;
        }

        if (newWindow) {
          newWindow.onload = function () {
            // Revoke the object URL when the window is closed
            newWindow.addEventListener("beforeunload", function () {
              URL.revokeObjectURL(url);
            });
          };
        }
      } catch {
        this.previewBlobAttachment();
      }
    },
    embedGrantData(approval) {
      this.showLoadingDialog();

      this.disabledApprovalGrantEmailBtn = !this.disabledApprovalGrantEmailBtn;

      // Embed
      if (approval) {
        this.formData.grantApprovalNo = this.grantEmailData.grantApprovalNo;
        this.formData.revertStatus = 1;
        this.formData.programmeName = this.grantEmailData.programmeName;
        this.formData.grantApprovalNoSubmitDate =
          this.grantEmailData.grantApprovalDate;
        this.formData.grantEmailAttachment = {
          name: "Grant Email Attachment.pdf",
        };
      }

      // Discharge
      if (!approval) {
        this.formData.grantApprovalNo = this.formData.oriGrantApprovalNo;
        this.formData.programmeName = this.formData.oriProgrammeName;
        this.formData.grantApprovalNoSubmitDate =
          this.formData.oriGrantApprovalDate;
        this.formData.grantEmailAttachment = null;
        this.formData.revertStatus = this.formData.oriGrantStatus;
      }

      this.hideLoadingDialog();
    },
    successRedirect(data) {
      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: this.eventRoute("ViewApplication"),
        query: {
          viewId: this.$store.state[this.service.key].data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
      this.$store.dispatch("showMessage", {
        message: data,
        messageType: "success",
        timeout: 2000,
      });
    },
    async submit() {
      this.showLoadingDialog();
      this.loadingText = "Submitting Grant & Form...";
      // Generate Form Data to handle multipart/form-data
      const fd = new FormData();
      fd.append("applicationUuid", this.formData.applicationNo);
      fd.append("remarks", this.formData.remarks);
      fd.append("programmeName", this.formData.programmeName);
      fd.append("grantApprovalNo", this.formData.grantApprovalNo);
      fd.append(
        "grantApprovalNoSubmitDate",
        this.formData.grantApprovalNoSubmitDate
      );
      fd.append("referById", this.auth.uuid);
      fd.append("jd14FileUrl", this.formData.jd14FileUrl);
      fd.append("t3FileUrl", this.formData.t3FileUrl);
      fd.append("revertStatus", this.formData.revertStatus); // Grant Revert Status
      fd.append("refundType", this.formData.refundType);
      fd.append("seventyPercent", this.formData.seventyPercent);
      fd.append("thirtyPercent", this.formData.thirtyPercent);
      fd.append("totalPrice", this.formData.totalPrice);
      fd.append("editMode", this.editMode);
      fd.append("formSubmitDate", this.formData.formSubmitDate);
      fd.append("formRevertStatus", this.formData.formRevertStatus); // Form Revert Status
      fd.append("formRemarks", this.formData.formRemarks);
      fd.append(
        "requestManualInvoiceAmount",
        this.formData.requestManualInvoiceAmount || ""
      );
      fd.append("rareCaseGrantFlag", this.rareCaseGrantFlag);
      if (this.showAttendanceForm) {
        fd.append("attendanceForm", this.formData.attendanceForm);
      }
      if (this.showAttendanceList) {
        fd.append("attendanceList", this.formData.attendanceList);
      }
      fd.append("hrdcType", this.hrdcType);

      const uploadFiles = ["jd14FileUrl", "t3FileUrl", "grantEmailAttachment"];
      if (this.showAttendanceForm) uploadFiles.push("attendanceForm");
      if (this.showAttendanceList) uploadFiles.push("attendanceList");
      fd.append("uploadFiles", uploadFiles);

      // If not File type, then will not do any checking for this file.
      let grantEmailAttachment = this.grantEmailData.emailAttachment;

      // If is edit mode & grant issue, then remove the grantEmailAttachment.
      if (this.editMode && !this.formData.revertStatus) {
        grantEmailAttachment = null;
      }

      let isGrantFileInstance = false;
      if (this.formData.grantEmailAttachment instanceof File) {
        grantEmailAttachment = this.formData.grantEmailAttachment;
        isGrantFileInstance = true;
      }
      fd.append("grantEmailAttachment", grantEmailAttachment);
      fd.append("isGrantFileInstance", isGrantFileInstance);
      fd.append("oriCompanyName", this.formData.companyName);

      this.apiSubmit.setParams(fd);
      this.apiSubmit.setCallbackError(() => {
        this.hideLoadingDialog();
        this.$store.dispatch("showMessage", {
          message: "Something went wrong. Please try again later.",
          messageType: "error",
          timeout: 2000,
        });
      });
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          const applicationData = response.application;

          if (!response.status) {
            this.showErrorMessage(response);
            if (response.message) {
              this.$store.dispatch("showMessage", {
                message: response.message,
                messageType: "error",
                timeout: 2000,
              });
            }

            this.hideLoadingDialog();
            return false;
          }

          // Response success, Grant Completed, Form Completed, current stage is before completed stage, HRDC Invoice No. is empty only need to generate HRDC invoice.
          if (
            response.status &&
            !applicationData.manualInvoiceToHrdc &&
            this.formData.revertStatus &&
            this.formData.formRevertStatus &&
            this.currentStagePriority <
              this.hrdcData.stageSlug.clientRevertT3Form
          ) {
            this.loadingText = "Generating HRDC Invoice...";
            const applicationLogData = applicationData.ApplicationLog.find(
              (item) =>
                item.stageId ==
                  this.hrdcData.stagePriority.subscriptionDateScheduled &&
                item.status == null
            );
            const trainingStartDate = this.convertDateFormat(
              applicationLogData.startDate
            );
            const trainingEndDate = this.convertDateFormat(
              applicationLogData.endDate
            );
            const trainingDate = `${trainingStartDate} to ${trainingEndDate}`;

            // Generate HRDC Invoice when completed.
            this.apiGetXeroRefreshToken.setCallbackCompleted(
              async (xeroTokenRes) => {
                try {
                  if (!xeroTokenRes || !xeroTokenRes.status) {
                    throw new Error(
                      "Unable to generate HRDC Invoice due to XERO invalid response, please contact administrator for assistance (1)"
                    );
                  }

                  // Check got valid refresh token or not, if yes, can direct call XERO API.
                  if (xeroTokenRes.data) {
                    const refreshToken = xeroTokenRes.data.token;

                    const token = await this.xeroRequestAccessToken(
                      this.apiRequestXeroAccessToken.url,
                      this.$store.state.auth.data.token,
                      refreshToken
                    );

                    const accessToken = token.data.access_token;

                    // Refresh the new refresh token in db.
                    this.apiRefreshXeroToken.setParams({
                      refresh_token: token.data.refresh_token,
                      token_id: xeroTokenRes.data.id,
                    });
                    this.apiRefreshXeroToken.fetch();

                    const connectionResponse = await this.xeroRequestTenantId({
                      url: `${
                        this.$service[this.service.key]
                      }/v1/en/console/xero/get-xero-tenant-id`,
                      headers: {
                        Authorization: `Bearer ${this.$store.state.auth.data.token}`,
                      },
                      postData: {
                        accessToken,
                      },
                    });

                    if (!connectionResponse || !connectionResponse.status) {
                      throw new Error(
                        "Unable to generate HRDC Invoice due to XERO invalid response, please contact administrator for assistance (2)"
                      );
                    }

                    const connectionData = connectionResponse.data;
                    const connection =
                      connectionData[connectionData.length - 1];
                    const tenantId = connection.tenantId;

                    const ContactID = process.env.VUE_APP_XERO_HRDC_CONTACT_ID;
                    const Code = process.env.VUE_APP_XERO_HRDC_ACCOUNT_CODE;
                    const TaxType =
                      process.env.VUE_APP_XERO_HRDC_ACCOUNT_TAX_TYPE;

                    // Get TaxRates
                    const taxRateObj = await this.xeroCallApi({
                      authorization: this.$store.state.auth.data.token,
                      service_key: this.model.serviceKey,
                      access_token: accessToken,
                      xero_tenant_id: tenantId,
                      api_type: "get_tax_rates",
                      method: "get",
                      postData: null,
                      url_suffix: `${TaxType}`,
                    });

                    const [taxRate] = taxRateObj.data.TaxRates.map(
                      (item) => item.EffectiveRate
                    );

                    // Start to do looping based on refund type (normal/70+30)
                    const LineItems = [];
                    let xeroProcessCount = 0;
                    const descriptionData = {
                      programmeName: this.formData.programmeName,
                      trainingDate,
                      companyName: applicationData.oriCompanyName,
                      grantApprovalNo: this.formData.grantApprovalNo,
                      note: null,
                    };

                    if (this.formData.refundType == 1) {
                      const {
                        unitAmount: requestInvoiceUnitAmount,
                        taxAmount: requestInvoiceTaxAmount,
                      } = this.calculateLineAmounts(
                        this.formData.requestManualInvoiceAmount,
                        taxRate
                      );

                      // Normal Claim
                      LineItems.push({
                        Description:
                          this.generateHrdcInvoiceDesc(descriptionData),
                        Quantity: 1,
                        LineAmount: requestInvoiceUnitAmount,
                        TaxType,
                        AccountCode: Code,
                        TaxAmount: requestInvoiceTaxAmount,
                        Tracking: [
                          { Name: "Division", Option: "taxPOD" },
                          {
                            Name: "MyInvois Classification",
                            Option: "022 - Others",
                          },
                        ],
                      });
                    }

                    if (this.formData.refundType == 2) {
                      // 70+30 Claim
                      const {
                        unitAmount: requestInvoice70UnitAmount,
                        taxAmount: requestInvoice70TaxAmount,
                      } = this.calculateLineAmounts(
                        this.formData.seventyPercent,
                        taxRate
                      );
                      const {
                        unitAmount: requestInvoice30UnitAmount,
                        taxAmount: requestInvoice30TaxAmount,
                      } = this.calculateLineAmounts(
                        this.formData.thirtyPercent,
                        taxRate
                      );

                      const additionalNote30 = `RM ${this.formData.thirtyPercent} - 30 % Upfront Payment`;
                      descriptionData.note = additionalNote30;
                      const Description30 =
                        this.generateHrdcInvoiceDesc(descriptionData);

                      descriptionData.note = `${additionalNote30}, RM ${this.formData.seventyPercent} - 70% Payment Upon Claim Approval.`;
                      const Description70 =
                        this.generateHrdcInvoiceDesc(descriptionData);

                      LineItems.push(
                        // 70%
                        {
                          Description: Description70,
                          Quantity: 1,
                          LineAmount: requestInvoice70UnitAmount,
                          TaxType,
                          AccountCode: Code,
                          TaxAmount: requestInvoice70TaxAmount,
                          Tracking: [
                            { Name: "Division", Option: "taxPOD" },
                            {
                              Name: "MyInvois Classification",
                              Option: "022 - Others",
                            },
                          ],
                        },
                        // 30%
                        {
                          Description: Description30,
                          Quantity: 1,
                          LineAmount: requestInvoice30UnitAmount,
                          TaxType,
                          AccountCode: Code,
                          TaxAmount: requestInvoice30TaxAmount,
                          Tracking: [
                            { Name: "Division", Option: "taxPOD" },
                            {
                              Name: "MyInvois Classification",
                              Option: "022 - Others",
                            },
                          ],
                        }
                      );
                    }

                    for (const LineItem of LineItems) {
                      // Construct data needed to request api to XERO.
                      const invoicePostData = {
                        Invoices: [
                          {
                            Type: this.INVOICE_TYPE,
                            Contact: {
                              ContactID,
                            },
                            Reference: this.TAXPOD_INVOICE_REFERENCE,
                            LineItems: [LineItem],
                            Status: this.getInvoiceStatus(),
                            DueDate: moment().format("YYYY-MM-DD"),
                            BrandingThemeID:
                              process.env.VUE_APP_XERO_BRANDING_THEME_ID,
                          },
                        ],
                      };

                      // Call XERO generate invoice api.
                      const generateInvoiceRes = await this.xeroCallApi({
                        authorization: this.$store.state.auth.data.token,
                        service_key: this.model.serviceKey,
                        access_token: accessToken,
                        xero_tenant_id: tenantId,
                        api_type: "post_invoices",
                        method: "post",
                        postData: invoicePostData,
                      });
                      const generateInvoiceResData = generateInvoiceRes.data;

                      if (
                        !generateInvoiceRes ||
                        generateInvoiceRes.status !== 200 ||
                        generateInvoiceResData.Status !== "OK"
                      ) {
                        throw new Error(
                          "HRDC Invoice created, but failed to upload invoice to system, please contact administrator for assistance"
                        );
                      }

                      // Construct GET HRDC Invoice attachments data.
                      const invoiceDetails =
                        generateInvoiceResData.Invoices.map((item) => {
                          return {
                            InvoiceID: item.InvoiceID, // A xero unique Invoice uuid
                            InvoiceNumber: item.InvoiceNumber, // e.g. YGC-XXXXXX
                            InvoiceDate: item.DueDateString,
                          };
                        });

                      // Call XERO GET Invoice via pdf api. (XERO API return PDF as pdf binary string type).
                      const hrdcInvoiceAtchRes = await this.xeroCallApi({
                        authorization: this.$store.state.auth.data.token,
                        service_key: this.model.serviceKey,
                        access_token: accessToken,
                        xero_tenant_id: tenantId,
                        api_type: "get_invoices",
                        method: "get",
                        postData: null,
                        url_suffix: `${invoiceDetails[0].InvoiceID}`,
                        accept_header: "application/pdf",
                        config: {
                          responseType: "arraybuffer", // Response received will be an PDF type of array buffer.
                          responseEncoding: "binary", // Response encoding using binary.
                        },
                      });

                      // Construct data to store in azure blob storage.
                      const arrayBuffer = hrdcInvoiceAtchRes.data;
                      const blob = new Blob([arrayBuffer], {
                        type: "application/pdf",
                      });
                      const file = new File([blob], "hrdc_invoice.pdf", {
                        type: "application/pdf",
                      });

                      const fd = new FormData();
                      fd.append("invoice", file);
                      fd.append("xeroProcessCount", xeroProcessCount);
                      fd.append("refundType", this.formData.refundType);
                      fd.append("applicationUuid", this.formData.applicationNo);
                      fd.append("referById", this.auth.uuid);
                      fd.append(
                        "hrdcInvoiceNo",
                        invoiceDetails[0].InvoiceNumber
                      );
                      fd.append("invoiceDate", invoiceDetails[0].InvoiceDate);
                      fd.append("clientNoXero", this.HRDC_CLIENT_NO);
                      fd.append(
                        "updateToStageId",
                        this.hrdcData.stagePriority.manualInvoiceToHrdc
                      );
                      fd.append(
                        "updateToStageName",
                        this.hrdcData.stageSlugToStageName.manualInvoiceToHrdc
                      );
                      fd.append(
                        "invoiceDateScheduled",
                        this.hrdcData.stagePriority.invoiceDateScheduled
                      );

                      // Store the HRDC Invoice PDF binary data to azure blob storage & update log.
                      await this.$axios
                        .post(
                          `${
                            this.$service[this.service.key]
                          }/v1/en/console/manual_invoice/process-hrdc-flow`,
                          fd,
                          {
                            headers: {
                              Authorization: `Bearer ${this.$store.state.auth.data.token}`,
                            },
                          }
                        )
                        .then((response) => {
                          try {
                            const { status, data } = response.data;
                            if (status) {
                              xeroProcessCount++;

                              if (xeroProcessCount == LineItems.length) {
                                this.successRedirect(data);
                              }
                            }
                          } catch (err) {
                            console.log(err);
                          }
                        });
                    }
                  } else {
                    // Else, need to autorize app and get a new refresh token.
                    const xeroParams = {
                      redirectCallbackUri: this.xeroRedirectUri,
                      stateType: this.$route.query._ausk,
                    };
                    const childWindow = window.open(
                      this.requestAuthorizeApp(xeroParams)
                    );
                    var timer = setInterval(() => {
                      if (childWindow.closed) {
                        this.successRedirect(response.data);
                        clearInterval(timer);
                      }
                    }, 500);
                  }
                } catch (err) {
                  console.log(err);
                  this.alertError.push(
                    "Failed to generate HRDC Invoice due to invalid credentials & this form is submitted, please contact admin for support!"
                  );
                  return false;
                } finally {
                  this.hideLoadingDialog();
                }
              }
            );

            this.apiGetXeroRefreshToken.fetch();
          } else {
            this.hideLoadingDialog();
            this.successRedirect(response.data);
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiSubmit.fetch();
    },
  },
};
</script>

<style scoped>
/* ============================================================================
   HRDC EVENT — REVERT (GRANT DETAILS + FORM DETAILS)
   ----------------------------------------------------------------------------
   Rebuilt on the same footing as hrdc/views/application/Add.vue.

   THIS PAGE IS A SHEET, NOT A STACK OF SLABS.

   The root is the routed <v-container>, so src/plugins/theme-glass.css §2 hands
   it the frosted panel, the rim, the lift and the WELD to the breadcrumb above.
   The old markup fought that: it painted its own #d8dce2 ground over the sheet,
   floated an #eaecef header slab on it, then floated #eaecef cards on THAT —
   three tones of the same grey inside a panel that already floats — and scaled
   the lot with `zoom: 1.1`, which browsers apply to layout but not to Vuetify's
   detached menu positioning, so every dropdown landed off its trigger.

   Now the ground, the zoom and the header slab are gone. The hero and the
   action bar paint CONTENT ON the sheet and carry no surface of their own;
   SURFACES are left to the glass layer, which styles .section-card,
   .section-body, .section-header, .file-card and .back-btn globally at (1,1,0)
   — above every scoped rule here. Restating their background/radius/shadow in
   this file would be dead CSS that reads as if it were in effect, so it is not
   restated. What is left below is only what that layer cannot know: the light
   header band (its icons are `color="white"` → .white--text !important, so a
   stylesheet that blanks the band would leave white glyphs on white), this
   page's own widgets, and spacing.

   NO LITERAL COLOURS. Every value is a var(--app-*) resolved by theme-dark.css.
   That is what collapsed the dark half of this file from ~200 rules spread over
   FOUR overlapping blocks (a generated one at the top, two hand-written ones in
   the middle, and per-widget stragglers — all disagreeing about which tier a
   field belongs to, with the bundler's emission order deciding the winner) down
   to the handful at the bottom that a token genuinely cannot express.
   ============================================================================ */

/* ============================================
   PAGE SHEET
   ============================================ */
.revert-page {
  /* Fills main minus the breadcrumb and footer. A `100vh - 64px` guess only
     subtracts the app bar and overflows — see .layout-main__content. */
  flex: 1 0 auto;
  padding: 28px 24px 56px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* The sheet spans the whole column like every other page; the two-card grid
   inside it stops widening once the columns are comfortable, instead of
   stretching one 180px label away from its field on a 1600px monitor.
   Centring lives here, not on the sheet, because the sheet's width and margins
   are owned by theme-glass. */
.revert-page__inner {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}

/* ============================================
   HERO — content on the sheet, not a card
   ============================================ */
.revert-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--app-border);
}

/* Surface, rim, radius and hover come from theme-glass §5 — only the box the
   button needs is set here. The button itself is new: redirectBack() has been
   in this component's methods all along with nothing in the template calling
   it, so the only way off this page was the breadcrumb. */
.back-btn {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--app-text-muted);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.back-btn:hover {
  color: var(--app-accent);
}

/* These icons carry no `color` prop, so they inherit the colour of the button
   around them and follow its hover state for free. Vuetify's own
   `.theme--light.v-icon` is (0,2,0); these are (0,2,0) plus the scope
   attribute, so they win without !important. */
.back-btn .v-icon,
.action-btn .v-icon {
  color: inherit;
}

.revert-hero__info {
  flex: 1;
  min-width: 0;
}

.revert-hero__eyebrow {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: var(--app-text-faint);
  margin-bottom: 3px;
}

.revert-hero__title {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--app-text);
  margin: 0;
  letter-spacing: -0.2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.revert-hero__info-icon {
  color: var(--app-text-faint) !important;
  vertical-align: -2px;
  margin-left: 4px;
  cursor: help;
  transition: color 0.15s ease;
}

.revert-hero__info-icon:hover {
  color: var(--app-accent) !important;
}

/* ============================================
   CARDS GRID
   ============================================ */
.cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

/* min-width: 0 is what lets a grid track shrink below its content; without it
   a long filename in a .file-card blows the column past its share and the
   whole page scrolls sideways. */
.cards-grid > * {
  min-width: 0;
}

@media (min-width: 960px) {
  .cards-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.cards-grid {
  margin-bottom: 24px;
}

.cards-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* ============================================
   SECTION CARDS
   --------------------------------------------
   Surface / rim / radius / lift / hover: theme-glass §4. Only the light band's
   paint and the interior spacing are this page's business.
   ============================================ */
.section-card {
  margin-bottom: 24px;
}

.section-card:last-child {
  margin-bottom: 0;
}

/* --app-brand-gradient, not a hand-rolled sky gradient: it is the token built
   for a saturated header in BOTH themes, and its -fg pairs with the white
   icons the template pins. Dark never sees it — theme-glass §4 neutralises the
   band app-wide from `html.dark-mode #app` (an id, so it wins). */
.section-header {
  background: var(--app-brand-gradient);
  padding: 15px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-header__title {
  color: var(--app-brand-gradient-fg);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 1.8px;
  text-transform: uppercase;
}

.section-body {
  padding: 26px 24px;
}

.section-divider {
  border: none;
  border-top: 1px solid var(--app-border);
  margin: 22px 0;
}

/* ============================================
   STATUS PILL (in the section header)
   ============================================ */
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  padding: 4px 11px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  flex-shrink: 0;
}

.status-pill__icon {
  width: 12px;
  height: 12px;
}

/* Light: the pill sits ON the brand band, so it needs an opaque chip to read
   at all — the tint tokens are calibrated against a card, not against a
   saturated blue. Dark gets the tint back below, where the band is neutral. */
.status-pill--complete {
  background: var(--app-card);
  color: var(--app-success);
}

.status-pill--incomplete {
  background: var(--app-card);
  color: var(--app-danger);
}

/* ============================================
   FORM GROUPS
   --------------------------------------------
   Label ABOVE the field, as on hrdc/application/Add.vue. The old 180px side
   label was sized for a full-width form; in a half-width grid column it ate
   40% of the row and left "Grant Approval No." wrapping to three lines beside
   a field too narrow to show its own value.
   ============================================ */
.form-group {
  margin-bottom: 20px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-group__label {
  display: block;
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--app-text);
  margin-bottom: 7px;
  line-height: 1.5;
}

/* The reference's info affordance: a tooltip target in the LABEL, not a glyph
   crammed into the control. That is where Refund Type's "70/30 needs 2 manual
   invoices" note now lives — it used to sit inside the select trigger, where
   clicking it had to stopPropagation to avoid opening the dropdown. */
.form-group__info {
  margin-left: 4px;
  color: var(--app-text-faint) !important;
  cursor: help;
  vertical-align: -2px;
  transition: color 0.15s;
}

.form-group__info:hover {
  color: var(--app-accent) !important;
}

/* The only row that still needs a box of its own: two fields side by side. */
.form-row--inline {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.form-row--inline > * {
  flex: 1;
  min-width: 0;
}

/* ============================================
   GRANT EMAIL CARD
   --------------------------------------------
   A tile ONE step in from the card, so it takes the form-tile tier and no
   shadow — a panel that floats inside a card reads as a second card.
   ============================================ */
.grant-email-card {
  background: var(--app-form-tile);
  border: 1px solid var(--app-form-tile-border);
  border-radius: var(--glass-radius-sm);
  overflow: hidden;
}

.grant-email-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: var(--app-surface);
  border-bottom: 1px solid var(--app-border);
}

.grant-email-card__icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--app-info-bg);
  color: var(--app-info-fg);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.grant-email-card__title {
  flex: 1;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--app-text);
}

.grant-email-card__actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

.grant-email-card__body {
  padding: 16px 18px;
}

.ge-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.ge-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
  font-size: 0.84rem;
  line-height: 1.6;
}

.ge-row__label {
  flex: 0 0 150px;
  font-weight: 500;
  color: var(--app-text-muted);
}

.ge-row__value {
  flex: 1;
  min-width: 0;
  font-weight: 600;
  color: var(--app-text);
  word-break: break-word;
}

.ge-row__value--highlight {
  color: var(--app-accent-strong);
  font-weight: 700;
}

.ge-attachment {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: var(--app-form-tile-hover);
  border: 1px dashed var(--app-field-border);
  border-radius: var(--glass-radius-sm);
}

.ge-attachment__icon {
  display: flex;
  flex-shrink: 0;
  color: var(--app-text-faint);
}

.ge-attachment__text {
  flex: 1;
  min-width: 0;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--app-text-muted);
}

.ge-attachment__btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border: 1px solid var(--app-accent-border);
  border-radius: 8px;
  background: var(--app-info-bg);
  color: var(--app-info-fg);
  font-family: inherit;
  font-size: 0.74rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.ge-attachment__btn:hover {
  background: var(--app-accent);
  border-color: var(--app-accent);
  color: var(--app-accent-fg);
}

/* Approve / Revert */
.ge-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.ge-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.ge-btn--approve {
  background: var(--app-success-bg);
  border-color: var(--app-success-border);
  color: var(--app-success-fg);
}

.ge-btn--approve:hover:not(:disabled) {
  background: var(--app-success);
  border-color: var(--app-success);
  color: var(--app-on-solid);
}

.ge-btn--revert {
  background: var(--app-danger-bg);
  border-color: var(--app-danger-border);
  color: var(--app-danger-fg);
}

.ge-btn--revert:hover:not(:disabled) {
  background: var(--app-danger);
  border-color: var(--app-danger);
  color: var(--app-on-solid);
}

/* ============================================
   GRANT FORMAT TOGGLE
   ============================================ */
.grant-input-wrap {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.grant-input-wrap > .v-input {
  flex: 1;
  min-width: 0;
}

.grant-format-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: var(--glass-radius-sm);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.grant-format-toggle--on {
  background: var(--app-success-bg);
  border-color: var(--app-success-border);
  color: var(--app-success-fg);
}

.grant-format-toggle--off {
  background: var(--app-danger-bg);
  border-color: var(--app-danger-border);
  color: var(--app-danger-fg);
}

.grant-format-toggle__track {
  position: relative;
  width: 32px;
  height: 18px;
  border-radius: 999px;
  flex-shrink: 0;
  transition: background 0.2s ease;
}

.grant-format-toggle--on .grant-format-toggle__track {
  background: var(--app-success);
}

.grant-format-toggle--off .grant-format-toggle__track {
  background: var(--app-border-strong);
}

.grant-format-toggle__thumb {
  position: absolute;
  top: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--app-card);
  box-shadow: 0 1px 3px var(--app-shadow);
  transition: left 0.2s ease;
}

.grant-format-toggle--on .grant-format-toggle__thumb {
  left: 16px;
}

.grant-format-toggle--off .grant-format-toggle__thumb {
  left: 2px;
}

/* Fixed width so the track does not shift sideways when the label flips
   between its two lengths. */
.grant-format-toggle__label {
  display: inline-block;
  width: 50px;
  text-align: left;
  letter-spacing: 0.3px;
}

/* ============================================
   FILE CARD
   --------------------------------------------
   Surface, rim, radius and hover: theme-glass §4 (.file-card is one of the two
   tile classes it owns app-wide). Only the layout and the badge are here.
   ============================================ */
.file-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  min-width: 0;
  overflow: hidden;
  transition: background 0.15s ease;
}

.file-card__icon-wrap {
  position: relative;
  flex-shrink: 0;
}

.file-card__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--app-danger-bg);
  color: var(--app-danger);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* The has-file / empty badge. Its ring is the TILE colour, not the card's, so
   the badge reads as punched out of the icon it overlaps. */
.file-card__icon-wrap::after {
  content: '';
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--app-form-tile);
  background-size: 10px;
  background-position: center;
  background-repeat: no-repeat;
}

/* The glyph is a data: URI, so it cannot take a token — it is drawn in white
   and always lands on a saturated success/danger fill, which is white-legible
   in both themes. */
.file-card--has-file .file-card__icon-wrap::after {
  background-color: var(--app-success);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m4.5 12.75 6 6 9-13.5'/%3E%3C/svg%3E");
}

.file-card--empty .file-card__icon-wrap::after {
  background-color: var(--app-danger);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18 18 6M6 6l12 12'/%3E%3C/svg%3E");
}

.file-card__svg {
  width: 20px;
  height: 20px;
}

.file-card__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-card__name {
  max-width: 100%;
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--app-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-card__hint {
  font-size: 0.72rem;
  color: var(--app-text-faint);
}

.file-card__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.file-card__btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--app-border);
  background: var(--app-card);
  color: var(--app-text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.file-card__btn:hover {
  background: var(--app-accent-soft);
  border-color: var(--app-accent-border);
  color: var(--app-accent-strong);
}

.file-card__btn-icon {
  width: 16px;
  height: 16px;
}

.file-card__hidden {
  display: none;
}

/* ============================================
   FIELD ERRORS
   --------------------------------------------
   For the controls Vuetify does not render a message list for — the file
   cards. Same size and colour as .app-input's .v-messages__message, so a
   failed upload and a failed text field read as the same kind of complaint.
   ============================================ */
.field-error {
  margin-top: 5px;
  font-size: 0.8rem;
  line-height: 1.3;
  color: var(--app-danger);
}

.field-error__list {
  margin: 0;
  padding-left: 16px;
  list-style: disc;
}

.field-error__list li {
  margin-bottom: 2px;
}

/* ============================================
   ACTION BAR
   --------------------------------------------
   The page's two terminal actions used to be 34px icon-only buttons in the
   header, distinguishable only by an arrow-vs-tick glyph, on a page whose
   whole job is deciding whether a case moves forward or goes back. They are
   labelled buttons at the end of the form now, in the same bar
   hrdc/application/Add.vue uses.
   ============================================ */
.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  padding-top: 20px;
  border-top: 1px solid var(--app-border);
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 30px;
  border-radius: var(--glass-radius-sm);
  font-family: inherit;
  font-size: 0.98rem;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.action-btn svg {
  width: 18px;
  height: 18px;
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.action-btn--revert {
  background: var(--app-warning-bg);
  border-color: var(--app-warning-border);
  color: var(--app-warning-fg);
}

.action-btn--revert:hover:not(:disabled) {
  background: var(--app-warning);
  border-color: var(--app-warning);
  color: var(--app-on-solid);
}

/* Submit is the page's one forward action, so it takes the brand gradient
   rather than a flat accent fill. */
.action-btn--submit {
  background: var(--app-brand-gradient);
  color: var(--app-brand-gradient-fg);
}

.action-btn--submit:hover:not(:disabled) {
  background: var(--app-brand-gradient-hover);
  box-shadow: 0 4px 14px var(--app-brand-glow);
  transform: translateY(-1px);
}

/* ============================================
   CONFIRM DIALOGS
   --------------------------------------------
   Deliberately NOT swapped for TheModalConfirmation: the submit dialog
   disables its own confirm button while apiSubmit is in flight, and that
   component has no way to express it — adopting it would trade ~60 lines of
   CSS for a double-submit. The card below is the same material as
   .confirm-card instead, token for token.
   ============================================ */
.revert-confirm-dialog {
  border-radius: var(--glass-radius-lg) !important;
  overflow: hidden;
  box-shadow: var(--glass-lift-modal) !important;
}

.revert-confirm-card {
  background: var(--app-navbar);
  border: 1px solid var(--app-border);
  border-radius: var(--glass-radius-lg);
  box-shadow: inset 0 1px 0 var(--app-inner-highlight);
  padding: 32px 32px 24px;
  text-align: center;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Opaque baseline above, frost here — see the note in theme-glass.css §3. */
@supports ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  .revert-confirm-card {
    background: var(--app-menu-glass);
    -webkit-backdrop-filter: blur(var(--glass-blur-panel)) saturate(var(--glass-saturate));
    backdrop-filter: blur(var(--glass-blur-panel)) saturate(var(--glass-saturate));
  }
}

.revert-confirm-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--app-text);
  margin: 0 0 10px;
}

.revert-confirm-card__message {
  font-size: 0.9rem;
  color: var(--app-text-muted);
  margin: 0 0 24px;
  line-height: 1.5;
}

.revert-confirm-card__actions {
  display: flex;
  gap: 12px;
}

.revert-confirm-card__btn {
  flex: 1;
  padding: 12px 16px;
  border: 1px solid transparent;
  border-radius: var(--glass-radius-sm);
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
}

.revert-confirm-card__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.revert-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  border-color: var(--app-border-strong);
  color: var(--app-text-muted);
}

.revert-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-field-border-hover);
  color: var(--app-text);
}

.revert-confirm-card__btn--confirm {
  background: var(--app-accent);
  color: var(--app-accent-fg);
}

.revert-confirm-card__btn--confirm:hover:not(:disabled) {
  box-shadow: 0 4px 12px var(--app-accent-glow);
}

.revert-confirm-card__btn--danger {
  background: var(--app-danger);
  color: var(--app-on-solid);
}

.revert-confirm-card__btn--danger:hover:not(:disabled) {
  box-shadow: 0 4px 12px var(--app-ring-danger);
}

/* ============================================
   DARK
   --------------------------------------------
   Everything above is token-driven, so dark needs only what a token cannot
   express: the section band (whose light paint is a saturated gradient) and
   the status pill that sits on it. The band itself is already neutralised
   app-wide by theme-glass §4 (`html.dark-mode #app .section-header` — an id,
   so it beats these rules on background). What is left is putting the accent
   back at CUE size rather than as a field, matching the other HRDC pages.
   ============================================ */
.dark-mode .section-header {
  position: relative;
}

/* 2px and faded top-to-bottom: it marks where the header starts without
   drawing a hard full-height rail. .section-card's overflow clips it to the
   card radius. */
.dark-mode .section-header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(
    180deg,
    rgba(var(--app-accent-rgb), 0.55),
    rgba(var(--app-accent-rgb), 0.12)
  );
}

.dark-mode .section-header__title {
  color: var(--app-text);
  letter-spacing: 1.6px;
}

/* The icon can hold the accent now that the band behind it is neutral.
   `color="white"` on the tag compiles to .white--text (0,1,0 + !important);
   this is (0,3,0 + !important) and wins. */
.dark-mode .section-header .v-icon {
  color: var(--app-accent) !important;
  opacity: 0.85;
}

/* With the band neutral, the pill no longer needs to be an opaque chip and can
   go back to the tint tokens the rest of the app uses for the same two states. */
.dark-mode .status-pill--complete {
  background: var(--app-success-bg);
  color: var(--app-success-fg);
}

.dark-mode .status-pill--incomplete {
  background: var(--app-danger-bg);
  color: var(--app-danger-fg);
}

/* ============================================
   TRANSITIONS
   ============================================ */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 959px) {
  .revert-page {
    padding: 20px 16px 44px !important;
  }

  .revert-hero__title {
    font-size: 1.12rem;
  }

  .cards-grid,
  .cards-column {
    gap: 20px;
  }

  .section-header {
    padding: 14px 18px;
  }

  .section-body {
    padding: 22px 18px;
  }

  .ge-row__label {
    flex: 0 0 132px;
  }
}

@media (max-width: 599px) {
  .revert-page {
    padding: 16px 12px 36px !important;
    overflow-x: hidden;
  }

  .revert-hero {
    gap: 12px;
  }

  .revert-hero__title {
    white-space: normal;
  }

  .cards-grid,
  .cards-column {
    gap: 16px;
  }

  .section-body {
    padding: 18px 14px;
    word-break: break-word;
  }

  .form-row--inline {
    flex-direction: column;
    gap: 12px;
  }

  .form-row--inline > * {
    width: 100%;
  }

  .grant-input-wrap {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .grant-email-card__header {
    flex-wrap: wrap;
    gap: 8px;
  }

  .grant-email-card__actions {
    width: 100%;
    justify-content: flex-end;
  }

  .ge-row {
    flex-direction: column;
    gap: 2px;
  }

  .ge-row__label {
    flex: none;
  }

  .form-actions {
    gap: 10px;
  }

  .action-btn {
    flex: 1;
    justify-content: center;
    padding: 12px 16px;
    font-size: 0.92rem;
  }

  .revert-confirm-card {
    padding: 24px 20px 20px;
  }

  .revert-confirm-card__title {
    font-size: 1.05rem;
  }
}
</style>

<style>
/* ============================================================================
   UNSCOPED — Vuetify chrome this page cannot reach from a scoped block.
   ----------------------------------------------------------------------------
   Two reasons a rule lands here rather than above:

   • The outlined <fieldset> and the message list are rendered by Vuetify
     OUTSIDE the component's scope id. `.revert-page` on every selector is what
     keeps those rules on this page.
   • The date picker is detached to [data-app] by v-menu, so no page selector
     reaches it at all. That block stays global — as it already was — but it no
     longer restates the menu's radius, border and shadow with !important:
     theme-glass §3 owns the menu surface app-wide, and the old rules here were
     overriding it (`border: none !important` on every .v-menu__content in the
     app, from a page most users never open) with a hard-coded light shadow.
   ============================================================================ */

/* --- Outlined inputs ------------------------------------------------------ */
.revert-page .app-input.v-text-field--outlined > .v-input__control > .v-input__slot {
  border-radius: var(--glass-radius-sm) !important;
  min-height: 48px;
}

/* Vuetify draws the outlined border on a <fieldset> that is absolutely
   positioned 5px ABOVE .v-input__slot (top: -5px, to make room for the
   floating-label notch), so filling the SLOT leaves that 5px band under the top
   border unpainted and the card colour shows through as a gap — invisible while
   --app-field and --app-card were both #fff, obvious the moment the field tier
   differs from the card. Fill the fieldset instead: it owns the border box.
   Then lift the field content above it, since an absolutely positioned fieldset
   paints over its static siblings. */
.revert-page .app-input.v-text-field--outlined fieldset {
  background: var(--app-field);
  border-color: var(--app-field-border) !important;
  border-radius: var(--glass-radius-sm) !important;
  transition: border-color 0.15s ease;
}

.revert-page .app-input .v-input__slot > *:not(fieldset) {
  position: relative;
  z-index: 1;
}

.revert-page .app-input.v-text-field--outlined:hover fieldset {
  border-color: var(--app-field-border-hover) !important;
}

.revert-page .app-input.v-input--is-focused fieldset {
  border-color: var(--app-accent) !important;
  border-width: 2px !important;
}

.revert-page .app-input .v-text-field__slot input,
.revert-page .app-input .v-text-field__slot textarea,
.revert-page .app-input.v-select .v-select__selection {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.98rem !important;
  font-weight: 600 !important;
  color: var(--app-text) !important;
}

.revert-page .app-input .v-text-field__slot input::placeholder,
.revert-page .app-input .v-text-field__slot textarea::placeholder {
  color: var(--app-field-placeholder) !important;
  font-weight: 500 !important;
}

.revert-page .app-input .v-label {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.98rem !important;
  color: var(--app-field-placeholder) !important;
}

/* The v-select chevron and the pickers' calendar glyph take the theme's default
   ink, which on the dark field is nearly the field's own colour. */
.revert-page .app-input .v-input__append-inner .v-icon,
.revert-page .app-input .v-input__prepend-inner .v-icon {
  color: var(--app-text-faint) !important;
}

/* Disabled fields read as a slot that is filled but locked, not as an empty
   one: a dashed rim plus the disabled tier, matching the read-only Subscription Date field
   beside them. */
.revert-page .app-input.v-input--is-disabled fieldset {
  background: var(--app-field-disabled);
  border-style: dashed !important;
  border-color: var(--app-field-disabled-border) !important;
}

.revert-page .app-input.v-input--is-disabled .v-text-field__slot input,
.revert-page .app-input.v-input--is-disabled .v-text-field__slot textarea {
  color: var(--app-text-muted) !important;
}

/* Error state */
.revert-page .app-input.v-input--has-state fieldset,
.revert-page .app-input.v-input--has-state:hover fieldset {
  border-color: var(--app-danger) !important;
}

.revert-page .app-input .v-messages__message {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.8rem !important;
  line-height: 1.3 !important;
  color: var(--app-danger) !important;
}

/* Vuetify's `hide-spin-buttons` covers Chrome; Firefox needs the appearance
   reset as well. */
.revert-page .app-input input[type="number"]::-webkit-inner-spin-button,
.revert-page .app-input input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.revert-page .app-input input[type="number"] {
  -moz-appearance: textbox;
}

/* --- Date picker (detached, so global) ------------------------------------ */
/* The picker is a .v-card inside .v-menu__content, which theme-glass §3 has
   already cleared to transparent — so these only need to clear the picker's
   own inner surfaces and hand every glyph a token. */
.v-picker {
  font-family: 'Lato', sans-serif !important;
}

.v-picker__body,
.v-date-picker-header {
  background: transparent !important;
}

.v-date-picker-header {
  padding: 12px 16px 8px !important;
}

.v-date-picker-header__value button {
  font-family: 'Lato', sans-serif !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  color: var(--app-text) !important;
}

.v-date-picker-header .v-btn {
  color: var(--app-text-muted) !important;
}

.v-date-picker-header .v-btn:hover {
  background: var(--app-hover) !important;
}

.v-date-picker-table thead th {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: var(--app-text-faint) !important;
  padding: 8px 0 !important;
}

.v-date-picker-table .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  color: var(--app-text) !important;
}

.v-date-picker-table .v-btn:hover {
  background: var(--app-hover) !important;
}

.v-date-picker-table .v-btn--active {
  background: var(--app-accent) !important;
  color: var(--app-accent-fg) !important;
  font-weight: 700 !important;
}

.v-date-picker-table .v-btn--outlined {
  border-color: var(--app-accent) !important;
  color: var(--app-accent) !important;
}

.v-date-picker-table .v-btn--disabled {
  color: var(--app-text-faint) !important;
}

.v-picker__actions {
  padding: 8px 16px 14px !important;
  background: transparent !important;
  border-top: 1px solid var(--app-border) !important;
}

.v-picker__actions .v-btn {
  font-family: 'Lato', sans-serif !important;
  font-weight: 700 !important;
  font-size: 0.82rem !important;
  letter-spacing: 0.3px !important;
  text-transform: none !important;
  border-radius: 8px !important;
  padding: 0 16px !important;
}

.v-date-picker-years li,
.v-date-picker-months .v-btn {
  font-family: 'Lato', sans-serif !important;
}
</style>
